import axios from 'axios';
import { toast } from 'react-toastify';

const resolveBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL;

  if (configured && configured.trim()) {
    return configured.trim();
  }

  // A silent fallback here means production builds quietly point at localhost,
  // so surface it loudly instead.
  const message =
    'REACT_APP_API_URL is not set. Create .env.local (or set it in your host) before building.';

  if (process.env.NODE_ENV === 'production') {
    throw new Error(message);
  }

  console.warn(`${message} Falling back to http://localhost:4000/`);
  return 'http://localhost:4000/';
};

const BASE_URL = resolveBaseUrl();

const fetchClient = () => {
  const instance = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  instance.interceptors.response.use(
    (successRes) => {
      toast.dismiss();
      return successRes;
    },
    (error) => {
      if (axios.isCancel(error) || error?.code === 'ERR_CANCELED') {
        return Promise.reject(error);
      }

      const status = error?.response?.status;
      const requestUrl = error?.config?.url || '';
      const isAdminDetailRequest = requestUrl.includes('/api/v1/admin_detail');
      const isLoginRequest = requestUrl.includes('/sessions');

      if (status === 401) {
        // Wrong current password for profile update can return 401.
        // Login failures should not force a redirect loop back to /login.
        if (!isAdminDetailRequest && !isLoginRequest) {
          toast.error(error?.response?.data?.message || 'Unauthorized');
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
        } else if (isLoginRequest) {
          toast.error(error?.response?.data?.message || 'Please check your credentials');
        }
      }

      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use((config) => {
    const isLoggedIn = !!localStorage.getItem('user');
    const token = localStorage.getItem('token');
    const url = config.url || '';

    if (isLoggedIn && !url.includes('s3.amazonaws.com')) {
      config.headers.Authorization = token ? `Bearer ${token}` : `Bearer ''`;
      config.headers.adminId = localStorage.getItem('adminId');
    }

    return config;
  });

  return instance;
};

export default fetchClient();
